import { useEffect, useState } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ICustomService } from "@common/SelectYourNumber/interface/ISubscription";
import { URLS } from "@constants";
import { AccountDetailsPage } from "@pages/AccountDetails/AccountDetailsPage";
import { AlertListPage } from "@pages/AlertList/AlertListPage";
import { BarringsPage } from "@pages/Barrings/BarringsPage";
import { BillsPage } from "@pages/Bills/BillsPage";
import { EmailVerificationPage } from "@pages/EmailVerification/EmailVerificationPage";
import { ForgotEmailPage } from "@pages/ForgotEmail/ForgotEmailPage";
import { HomePage } from "@pages/Home/HomePage";
import { ManageSimPage } from "@pages/ManageSim/ManageSimPage";
import { OrderPage } from "@pages/Order/OrderPage";
import { PaymentPage } from "@pages/Payment/PaymentPage";
import { PortInPage } from "@pages/PortIn/PortInPage";
import { ProfilePage } from "@pages/Profile/ProfilePage";
import "./stylesheets/index.scss";
import { getSelectedService, saveSelectedService } from "@utils/storage";
import { UsagePage } from "@pages/Usage/UsagePage";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { Footer } from "@common/Footer/Footer";
import { AuthRoute, NonAuthRoute } from "./Routes";
import { ScrollTopButton } from "@common/ScrollTopButton/ScrollTop";
import { IConfigSwr } from "itsf-ui-common";
import { fetcher } from "@utils/fetcher";
import { SWRConfig } from "swr";
import { CancelBroadbandPage } from "@pages/CancelBroadband/CancelBroadbandPage";
import { AddonsPage } from "@pages/Addons/AddonsPage";

export const App = () => {
    const [selectedService, setSelectedService] = useState<ICustomService | undefined>(getSelectedService());

    const defaultSWROptions: IConfigSwr = {
        revalidateOnMount: true,
        fetcher,
    };

    useEffect(() => {
        saveSelectedService(selectedService);
    }, [selectedService]);

    return (
        <div id="app-container">
            <SWRConfig value={defaultSWROptions}>
                <SelectedServiceContext.Provider value={{ selectedService, setSelectedService }}>
                    <div style={{ flexGrow: 1 }}>
                        <Switch>
                            <AuthRoute component={HomePage} exact path={URLS.HOME_PAGE_URL} />
                            <AuthRoute component={ProfilePage} exact path={URLS.PROFILE_PAGE_URL} />
                            <AuthRoute component={BillsPage} exact path={URLS.BILLS_PAGE_URL} />
                            <AuthRoute component={UsagePage} exact path={URLS.USAGE_PAGE_URL} />
                            <AuthRoute component={AccountDetailsPage} exact path={URLS.ACCOUNT_DETAILS_PAGE_URL} />
                            <AuthRoute component={AddonsPage} exact path={URLS.ADDONS_PAGE_URL} />
                            <AuthRoute component={CancelBroadbandPage} exact path={URLS.CANCEL_BROADBAND_PAGE_URL} />
                            <AuthRoute component={OrderPage} exact path={URLS.ORDERS_PAGE_URL} />
                            <AuthRoute component={AlertListPage} exact path={URLS.ALERTS_PAGE_URL} />
                            <AuthRoute component={PaymentPage} exact path={URLS.PAYMENTS_PAGE_URL} />
                            <AuthRoute component={PortInPage} exact path={URLS.PORTIN_PAGE_URL} />
                            <AuthRoute component={ManageSimPage} exact path={URLS.MANAGE_SIM_URL} />
                            <AuthRoute component={BarringsPage} exact path={URLS.BARRINGS_PAGE_URL} />
                            <NonAuthRoute component={ForgotEmailPage} exact path={URLS.FORGOT_EMAIL_PAGE_URL} />
                            <NonAuthRoute
                                component={EmailVerificationPage}
                                exact
                                path={URLS.EMAIL_VERIFICATION_PAGE_URL}
                            />
                            <Redirect to={URLS.HOME_PAGE_URL} />
                        </Switch>
                    </div>
                    <ScrollTopButton />
                    <Footer />
                </SelectedServiceContext.Provider>
            </SWRConfig>
        </div>
    );
};
